import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ThemeToggle from './components/ThemeToggle';
import './App.css';

// Lazy load components for better performance
const Home = lazy(() => import('./components/Home'));
const Projects = lazy(() => import('./components/Projects'));
const Contact = lazy(() => import('./components/Contact'));
const Privacy = lazy(() => import('./components/Privacy'));
const Terms = lazy(() => import('./components/Terms'));
const Cookies = lazy(() => import('./components/Cookies'));

// Loading component
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh',
    fontSize: '1.2rem',
    color: '#667eea'
  }}>
    <div style={{
      width: '40px',
      height: '40px',
      border: '4px solid #f3f3f3',
      borderTop: '4px solid #667eea',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginRight: '15px'
    }}></div>
    Loading...
  </div>
);

function App() {
  // Google Analytics setup
  useEffect(() => {
    // Add Google Analytics tracking code here
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID';
    document.head.appendChild(script);

    // Initialize dataLayer and gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'GA_MEASUREMENT_ID', {
      page_title: 'CodeViaje - Innovative IT Solutions',
      page_location: window.location.href,
      custom_map: {
        'custom_parameter_1': 'project_type'
      }
    });
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <a href="#main-content" className="skip-link">Skip to main content</a>
          <Header />
          <ThemeToggle />
          <main id="main-content" role="main">
            <Suspense fallback={<LoadingSpinner />}>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/Projects" element={<Projects />} />
                        <Route path="/Contact" element={<Contact />} />
                        <Route path="/Privacy" element={<Privacy />} />
                        <Route path="/Terms" element={<Terms />} />
                        <Route path="/Cookies" element={<Cookies />} />
                      </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
